<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="storageRoomTable" :tab="$t('tab.storageRoomData')" style="margin-top: -14px">
        <storageRoom-table ref="storageRoomTable" :storage-environments="storageEnvironments" :storage-room-types="storageRoomTypes" @dblClick="dblClick"/>
      </a-tab-pane>
      <a-tab-pane key="shipmentRuleTable" :tab="$t('tab.shipmentRule')" forceRender style="margin-top: -14px">
        <storage-room-shipment-rule-table ref="shipmentRuleTable" :pack-types="packTypes"/>
      </a-tab-pane>
      <a-tab-pane key="replenishmentRuleTable" :tab="$t('tab.replenishmentRule')" forceRender style="margin-top: -14px">
        <storage-room-replenishment-rule-table ref="replenishmentRuleTable" :transmission-types="transmissionTypes"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
        <vxe-button content="button.export" size="mini" status="info" @click="exportExcel"/>
      </a-space>
    </a-tabs>
  </a-layout>
</template>

<script>
import { findEnum } from '@/api/Api'
import StorageRoomTable from '@/views/basedata/storageroom_maintenance/StorageRoomTable.vue'
import StorageRoomShipmentRuleTable from '@/views/basedata/storageroom_maintenance/StorageRoomShipmentRuleTable.vue'
import StorageRoomReplenishmentRuleTable from '@/views/basedata/storageroom_maintenance/StorageRoomReplenishmentRuleTable.vue'
import StorageRoomEdit from '@/views/basedata/storageroom_maintenance/StorageRoomEdit.vue'

export default {
    name: 'StorageRoomBaseData',
    components: { StorageRoomTable, StorageRoomEdit, StorageRoomShipmentRuleTable, StorageRoomReplenishmentRuleTable },
    data() {
      return {
        activeKey: 'storageRoomTable',
        storageRoomTypes: [],
        storageEnvironments: [],
        packTypes: [],
        transmissionTypes: []
      }
    },
    created() {
      findEnum('StorageRoomType').then(res => {
        if (res.success) {
          this.storageRoomTypes = res.result.map(item => {
            return { label: item.name, value: item.ordinal }
          })
        }
      })
      findEnum('StorageEnvironment').then(res => {
        if (res.success) {
          this.storageEnvironments = res.result.map(item => {
            return { label: item.name, value: item.ordinal }
          })
        }
      })
      findEnum('PackType').then(res => {
        this.packTypes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      })
      findEnum('TransmissionType').then(res => {
        this.transmissionTypes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      })
    },
    activated() {
      this.refresh()
    },
    methods: {
      dblClick(record) {
        this.activeKey = 'shipmentRuleTable'
        this.$refs.shipmentRuleTable.refresh(record)
        this.$refs.replenishmentRuleTable.refresh(record)
      },
      add() {
        this.$refs[this.activeKey].add()
      },
      save() {
        this.$refs[this.activeKey].save()
      },
      refresh() {
        this.$refs[this.activeKey].refresh()
      },
      reset() {
        this.$refs[this.activeKey].reset()
      },
      exportExcel() {
        this.$refs[this.activeKey].exportExcel()
      }
    }
  }
</script>